import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-hold-report',
  templateUrl: './hold-report.component.html',
  styleUrls: ['./hold-report.component.scss']
})
export class HoldReportComponent implements OnInit {
  apptId: any;
  buttonText: string="Receive Payment";

  constructor(private formBuilder: FormBuilder,private spinner:NgxSpinnerService,private http:HttpClient,private appointmentService:AppointmentService,
    private authenticationService:AuthenticationService, private authService:AuthenticationService,private router:Router) { }
    paymentAmount!:any
  value:String="Upcoming";
  appointments:any=[]
  userRole:any
  status!:string
  filterForm!: FormGroup;
  tests:any
  surveys:any
  selectedTests:any
  selectedSurveys:any
  show:boolean=false
  scheduleId:any

  ngOnInit(): void {
    this.show=false
    let location=null;
    let diagId= null;
    let status="HOLD";
    this.spinner.show()
    this.userRole = this.authService.getUserType()
    if(this.userRole!='ADMIN' && this.userRole!='DIRECTOR'){
      diagId= this.authenticationService.getUserId();
    }
    this.appointmentService.getAppointments(location,diagId,status,null,null,null).subscribe((res: any)=>{
      this.appointments=res.data;
      this.show=true
      this.spinner.hide()
    })

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    });
  }
  updateApptId(id:any){
    this.apptId=id;
  }

  HoldAndUnHoldAppt(action:any) {
    //  let action = "HOLD"
      this.appointmentService.updateAppts(action, this.apptId, null, null).subscribe(res => {
        this.router.navigate(['/appt-all-details',this.apptId]);
      })
    }


  submitFilterForm() {
    this.spinner.show()
    this.appointmentService.getAppointments(null,null,"HOLD",null, this.filterForm.controls['fromDate'].value, this.filterForm.controls['toDate'].value).subscribe((res: any)=>{
      this.appointments=res.data;
      this.show=true
      this.spinner.hide()
    })
  }

  getAppointments(){

  }
  selectValue(value:string){
    this.value=value;
  }
  setApptId(apptId:any){
    this.apptId=apptId
  }
  
 submitPayment(){

    this.appointmentService.updateAppts("FOLLOWUP",this.apptId,null,null).subscribe(res=>{
       })
   }
   redirectHome(){
     location.reload()
   }

}
